module.exports = __webpack_public_path__ + "static/media/Walton-Family-Foundation.1985cc2a.png";